/* generated using openapi-typescript-codegen -- do not edit */
/* istanbul ignore file */
/* tslint:disable */
/* eslint-disable */
export type BookingDetailSessionItemDto = {
    /**
     * Session UUID
     */
    id: string;
    /**
     * Session number
     */
    sessionNumber: number;
    /**
     * Scheduled start time
     */
    scheduledStartTime: string;
    /**
     * Scheduled end time
     */
    scheduledEndTime: string;
    /**
     * Session status
     */
    status: BookingDetailSessionItemDto.status;
    /**
     * Attendance status
     */
    attendanceStatus?: BookingDetailSessionItemDto.attendanceStatus;
    /**
     * Session notes
     */
    sessionNotes?: Record<string, any>;
    /**
     * Latest reschedule request status
     */
    rescheduleStatus?: BookingDetailSessionItemDto.rescheduleStatus | null;
    /**
     * Reason provided for the reschedule request
     */
    rescheduleReason?: Record<string, any> | null;
    /**
     * Refund status for this session
     */
    refundStatus?: BookingDetailSessionItemDto.refundStatus | null;
    /**
     * Refund amount for this session
     */
    refundAmount?: Record<string, any> | null;
};
export namespace BookingDetailSessionItemDto {
    /**
     * Session status
     */
    export enum status {
        SCHEDULED = 'scheduled',
        IN_PROGRESS = 'in_progress',
        COMPLETED = 'completed',
        CANCELLED = 'cancelled',
        RESCHEDULED = 'rescheduled',
    }
    /**
     * Attendance status
     */
    export enum attendanceStatus {
        PENDING = 'pending',
        MARKED = 'marked',
        ACCEPTED = 'accepted',
        REJECTED = 'rejected',
    }
    /**
     * Latest reschedule request status
     */
    export enum rescheduleStatus {
        PENDING = 'pending',
        ACCEPTED = 'accepted',
        DECLINED = 'declined',
    }
    /**
     * Refund status for this session
     */
    export enum refundStatus {
        PENDING = 'pending',
        APPROVED = 'approved',
        DECLINED = 'declined',
        PROCESSED = 'processed',
        FAILED = 'failed',
    }
}

